import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import * as actionCreators from "../../../redux/store/actions/index"
import "./slist-popup.styles.scss";

const SlistPopup = ({ show, barcode, amount, onClose }) => {
    const slists = useSelector(state => state.slists.slists);
    const currentSlist = useSelector(state => state.slists.currentSlist);
    const [slistId, setSlistid] = useState(currentSlist.id);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const onSubmit = (slistId) => {
        if (slistId) {
            dispatch(actionCreators.itemCreate(slistId, barcode, amount));
            onClose();
        }
    }

    return (
        <Modal show={show} centered={true} onHide={onClose} dialogClassName="slist-popup">
            <Modal.Header
                className="slist-popup-header"
                closeButton>
                {t("smartlist.popup.header")}
            </Modal.Header>
            <div className="slist-popup-content">
                <div className="slist-popup-title">{t("smartlist.popup.title")}</div>
                <div className="slist-popup-lists">
                    {slists && slists.map(slist => (
                        <button className={`outline ${slist.id === slistId ? "selected" : ""}`}
                            key={slist.id}
                            onClick={() => setSlistid(slist.id)}>
                            {slist.title}
                        </button>
                    ))}
                </div>
                <div className="slist-popup-actions">
                    <button className="cta" onClick={() => onSubmit(slistId)}>
                        <span>{t("smartlist.popup.action")}</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default SlistPopup;